import { render, staticRenderFns } from "./leadAllocationList.vue?vue&type=template&id=7141a116"
import script from "./leadAllocationList.vue?vue&type=script&lang=js"
export * from "./leadAllocationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports